import * as ko from 'knockout';

import { Deferred } from '../utils/deferred';
import { app } from '../app';
import { I18nText, translate } from '../i18n_text';
import { StageChangeChartData, recordStageChangeChart } from '../api/overview';

let template = require('raw-loader!../../templates/components/record_stage_change_chart.html').default;

class RecordStageChangeChart {
  private id: string;
  result: Deferred<{}>;

  loading = ko.observable(true);
  data = ko.observable<StageChangeChartData>();

  constructor(params: { id: string; result: Deferred<{}> }) {
    this.id = params.id;
    this.result = params.result;

    this.fetch();
  }

  private async fetch() {
    try {
      this.data(await recordStageChangeChart(this.id));
    } finally {
      this.loading(false);
    }
  }

  onClose = () => {
    this.result.resolve(null);
  };
}

ko.components.register('record-stage-change-chart', {
  viewModel: RecordStageChangeChart,
  template: template,
});

export function openRecordStageChangeChart(variety: { id: string; name: string | I18nText }) {
  app.formsStackController.push({
    title: translate(variety.name),
    name: 'record-stage-change-chart',
    showNav: true,
    className: 'record-stage-change-chart',
    params: { id: variety.id, result: new Deferred<{}>() },
  });
}
